const SidebarProfile = ({ width = "18", height = "18", opacity = "1" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity={opacity}
        d="M9.99992 0.833313C4.93992 0.833313 0.833252 4.93998 0.833252 9.99998C0.833252 15.06 4.93992 19.1666 9.99992 19.1666C15.0599 19.1666 19.1666 15.06 19.1666 9.99998C19.1666 4.93998 15.0599 0.833313 9.99992 0.833313ZM5.48075 15.7566C5.87492 14.9316 8.27659 14.125 9.99992 14.125C11.7233 14.125 14.1341 14.9316 14.5191 15.7566C13.2724 16.7466 11.7049 17.3333 9.99992 17.3333C8.29492 17.3333 6.72742 16.7466 5.48075 15.7566ZM15.8299 14.4275C14.5191 12.8325 11.3383 12.2916 9.99992 12.2916C8.66159 12.2916 5.48075 12.8325 4.16992 14.4275C3.1961 13.1568 2.66778 11.6009 2.66659 9.99998C2.66659 5.95748 5.95742 2.66665 9.99992 2.66665C14.0424 2.66665 17.3333 5.95748 17.3333 9.99998C17.3333 11.6683 16.7649 13.1991 15.8299 14.4275ZM9.99992 4.49998C8.22159 4.49998 6.79159 5.92998 6.79159 7.70831C6.79159 9.48665 8.22159 10.9166 9.99992 10.9166C11.7783 10.9166 13.2083 9.48665 13.2083 7.70831C13.2083 5.92998 11.7783 4.49998 9.99992 4.49998ZM9.99992 9.08331C9.23909 9.08331 8.62492 8.46915 8.62492 7.70831C8.62492 6.94748 9.23909 6.33331 9.99992 6.33331C10.7608 6.33331 11.3749 6.94748 11.3749 7.70831C11.3749 8.46915 10.7608 9.08331 9.99992 9.08331Z"
        fill="white"
      />
    </svg>
  );
};
export default SidebarProfile;
